import { ORDER_ACCEPT as $ST } from 'plugins/tfs/platformConfigs/staticTextMaps/order';
import $STP from 'plugins/tfs/platformConfigs/staticTextMaps/product';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { openImageModal } from 'actions/imageModal';
import PageTitle from 'theme/PageTitle';
import Button from 'theme/Button';
import Icon from 'theme/Icon';
import Image from 'theme/Image';
import SubModal from 'theme/SubModal';
import ModalSpinner from 'theme/ModalSpinner';
import Clear from 'theme/Clear';
import { orderStatus, thumbnailImageUrl } from 'theme/utils';
import Error from 'theme/Error';
import { useDispatch } from 'react-redux';

// pageContainer
import OrderAcceptComplete from '_pageContainers/orders/acceptComplete';

const OrderAcceptCompleteGrid = (pageContext) => {
  const dispatch = useDispatch();

  const {
    props: { order, error, pending, currentStaff, success },
    redirect,
    successModal,
    acceptOrderData,
    cleanStateAndRedirect,
    closeModal,
    printPage,
  } = pageContext;

  const renderOrderItems = (orderItems) => {
    return orderItems.map((oi, index) => {
      const image =
        oi.product.productimage_set.length &&
        oi.product.productimage_set[0].image;
      return (
        <div className='row order-refund-complete-item' key={index}>
          <div className='col-3' style={{ border: '1px solid #ddd' }}>
            <Image
              src={thumbnailImageUrl(image, 90, 90)}
              classes={'product-item__imageWrapper'}
              width={90}
              height={90}
              onClick={() =>
                dispatch(openImageModal(thumbnailImageUrl(image, 600, 600)))
              }
            />
          </div>
          <div
            className='col-9'
            style={{
              border: '1px solid #ddd',
              borderLeft: '0',
              padding: '20px',
            }}
          >
            <div
              className='row'
              style={{ fontSize: '13px', lineHeight: '24px' }}
            >
              <div className='col-12'>
                <strong>{oi.product.sku}</strong>
                <p>{oi.product.name}</p>
                <p>
                  {oi.product.price} {oi.product.price_currency}
                </p>
                {/* TODO: FIX HERE ACCORDING TO INTEGRATION MAP */}
                <p>
                  {oi.product.attributes.renk} {oi.product.attributes.beden}
                </p>
                <p>{orderStatus(oi.status)}</p>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  if (!order.pk || redirect) {
    return <Redirect to={$R.ORDER_ACCEPT_SEARCH.path} />;
  }

  return (
    <div className='continer-fluid'>
      {pending && <ModalSpinner />}
      {successModal && success && (
        <SubModal
          classes='text-center inner-centered'
          onClose={closeModal}
          buttonText={$STP.OKAY}
        >
          <p style={{ margin: '30px 0' }}>{$ST.ORDER_ACCEPTED}</p>
          <br />
          <Button
            classes='button pointer float-left'
            onClick={() => printPage()}
          >
            {$ST.PRINT}
          </Button>
          <Clear />
          <br />
          <br />
        </SubModal>
      )}
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div
            className='login_form-container'
            style={{ padding: '80px 30px 0' }}
          >
            <div style={{ margin: '0 -17px' }}>
              <PageTitle classes='hide-on-print'>
                <Button
                  classes='pointer float-left'
                  onClick={() => cleanStateAndRedirect()}
                >
                  {$ST.SHOP_ORDER_ACCEPTANCE}
                </Button>
                <span style={{ fontSize: '16px', margin: '0 5px' }}>
                  <Icon icon='oksag' />
                </span>
                {$ST.ORDER_DELIVERY}
              </PageTitle>
              <br />
              <br />
              <br />
              <h4 className='form-title-hero'>
                {$ST.ORDER_THAT_RECEIVED} ({order.number})
              </h4>
              <h4 className='form-title-hero'>
                {order.orderitem_set.length} {$ST.PIECES} ({$ST.INVOICE_NUMBER}{' '}
                {order.invoice_number})
              </h4>
            </div>
            <div className='show-on-print' style={{ margin: '0 -17px' }}>
              <h4 className='form-title-hero'>{$ST.STAFF_WHO_DELIVER}</h4>
              <p style={{ marginBottom: '15px' }}>
                <strong>
                  {currentStaff.first_name} {currentStaff.last_name}
                </strong>
              </p>
              <p>{currentStaff.current_store.name}</p>
              <p style={{ marginBottom: '30px' }}>
                {currentStaff.current_store.id}
              </p>
            </div>
            {renderOrderItems(order.orderitem_set)}
          </div>
        </div>
        <div
          className='col-12 col-md-6 store-select-wrapper hide-on-print'
          style={{ paddingTop: '90px' }}
        >
          <h4 className='form-title-hero'>{$ST.STAFF_WHO_RECEIVE}</h4>
          <p style={{ marginBottom: '15px' }}>
            <strong>
              {currentStaff.first_name} {currentStaff.last_name}
            </strong>
          </p>
          <p>{currentStaff.current_store.name}</p>
          <p style={{ marginBottom: '30px' }}>
            {currentStaff.current_store.id}
          </p>
          <Error data={error} field='order' />
          <Error data={error} field='cancel_items' />
          <Error data={error} field='reasons' />
          <Error data={error} field='forced_refund_amount' />
          <Error data={error} field='non_field_errors' />
          <br />
          <Button
            classes='button pointer float-left'
            onClick={() => acceptOrderData()}
            disabled={pending}
          >
            {$ST.RECEIVED}
          </Button>
          <Clear />
        </div>
      </div>
    </div>
  );
};

export default OrderAcceptComplete(OrderAcceptCompleteGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/orders/acceptComplete/index.js